import { array } from '../typing/array.js';
import { literal } from '../typing/literal.js';
import { object } from '../typing/object.js';
import { string } from '../typing/string.js';
import { union } from '../typing/union.js';
import { EventAuth } from '../event-store/event-auth.js';
import { optional } from '../typing/optional.js';
import { declareEvent } from '../storage/declare-event.js';
import { defineEvents } from '../stream/define-events.js';
import { TypeOf } from '../typing/type-of.js';

export const AccessLevel = union('AccessLevel', [
  literal('read'),
  literal('write'),
]);

export const FieldFilter = object('FieldFilter', {
  field: string(),
  value: string(),
});

export const TerminalMethod = union('TerminalMethod', [
  literal('get'),
  literal('range'),
  literal('observe'),
  literal('iterate'),
  literal('observeRange'),
]);

export const EventGrant = object('EventGrant', {
  event: string(),
  filters: array(FieldFilter),
  access: AccessLevel,
});

export const StateGrant = object('StateGrant', {
  state: string(),
  methods: array(TerminalMethod),
  filters: array(FieldFilter),
  access: AccessLevel,
});

export const EventRevoke = object('EventRevoke', {
  event: string(),
  access: AccessLevel,
});

export const StateRevoke = object('StateRevoke', {
  state: string(),
  access: AccessLevel,
});

export const PermissionEvents = defineEvents([
  declareEvent('grant-access', {
    auth: EventAuth,
    eventGrants: optional(array(EventGrant)),
    stateGrants: optional(array(StateGrant)),
  }),
  declareEvent('revoke-access', {
    auth: EventAuth,
    eventGrants: optional(array(EventRevoke)),
    stateGrants: optional(array(StateRevoke)),
  }),
]);

export type AccessLevelType = TypeOf<typeof AccessLevel>;
export type FieldFilterType = TypeOf<typeof FieldFilter>;
export type EventGrantType = TypeOf<typeof EventGrant>;
export type StateGrantType = TypeOf<typeof StateGrant>;
export type EventRevokeType = TypeOf<typeof EventRevoke>;
export type StateRevokeType = TypeOf<typeof StateRevoke>;
